<template>
  <div class="page-wrapper member-wrap">
    <div class="container-fluid">
      <breadcrumb :items="breadcrumbItems" />
      <div class="d-flex justify-content-between align-items-center">
        <div class="page-title">
          <h1>Configure Commission Split</h1>
        </div>
        <div class="btn-section d-flex justify-content-end">
          <button class="univ-btn m-0" @click="openAddDialog">
            + Add Split
          </button>
        </div>
      </div>

      <div class="row member-card member-card-list">
        <QuickFilterInput @search="handleSearch" />

        <div class="top-pagination">
          <div class="view-quote-pagination">
            <pagination :rows="paginationData" :filters="filters" :renewal-status="false"
              @update:rows="handlePaginationUpdate" @page-change="handlePageChange" />
          </div>
        </div>

        <div class="table-responsive p-0">
          <table class="w-100" :key="tableKey">
            <thead>
              <tr>
                <th>From Rep</th>
                <th>Seller Reps</th>
                <th>To Rep</th>
                <th>Split %</th>
                <th>Effective Date</th>
                <th>Updated By</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              <template v-if="rows.length === 0">
                <tr>
                  <td colspan="8" class="text-center">No data available</td>
                </tr>
              </template>
              <template v-else>
                <tr v-for="(row, index) in rows" :key="`row-${row.id || index}-${tableKey}`">
                  <td class="fw-medium">
                    {{ row.from_rep.name }}
                    <br />[{{ row.from_rep.code }}]
                  </td>
                  <td class="seller-reps">
                    {{ sellerRepsDisplay(row.seller_reps) }}
                  </td>
                  <td>
                    <span class="fw-medium">{{ row.to_rep.name }}</span>
                    <br />({{ row.to_rep.code }})
                  </td>
                  <td>
                    <p class="split-pill">FROM: {{ row.split.from }}</p>
                    <p class="split-pill">TO: {{ row.split.to }}</p>
                  </td>
                  <td>{{ formatDate(row.effective_date) }}</td>
                  <td class="fw-medium">{{ row.updated_by || '-' }}</td>

                  <td>
                      <div class="dropdown">
                        <button class="btn status-btn" :class="row.status === 'Enable' ? 'btn-enable' : 'btn-disable'" type="button" @click.stop="toggleDropdown(row.id)">
                          {{ row.status }} ▾
                        </button>
                        <div v-show="activeDropdown === row.id" class="dropdown-menu show status-drp-down" style="position: absolute; z-index: 999">
                          <a class="dropdown-item enable-txt stat-text" v-if="row.status !='Enable'"  @click="changeStatus(index, 'Enable',row.id)">
                            <span class="enable-dot"></span>Enable
                          </a>
                          <a class="dropdown-item disable-txt stat-text" v-if="row.status !='Disable'" @click="changeStatus(index, 'Disable',row.id)">
                            <span class="disable-dot"></span>Disable
                          </a>
                        </div>
                      </div>
                    </td>

                  <td>
                    <div class="action-icons">
                      <!-- <custom-button title="Edit" iconClass="fa fa-pencil-alt" className="icon-btn icon-edit"
                        @click.native="openEditDialog(row)" /> -->
                      <custom-button title="Activity" iconClass="fa fa-clock" className="icon-btn icon-edit"
                        @click.native="getHistory(row.id)" />
                      <custom-button title="Delete" iconClass="fa fa-trash" className="sign-incomplete"
                        @click.native="openDeleteDialog(row.id)" />
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>

        <div class="mt-3">
          <pagination :rows="paginationData" :filters="filters" @update:rows="handlePaginationUpdate" />
        </div>
        <all-seller :visible="dialog" @close="dialog = false" />
        <add-comm :visible="dialogAddComm" @close="closeComm('add')" @reload="reload" />
        <edit-comm :visible="dialogEditComm" @close="closeComm('edit')" :data="selectedSplit" @reload="reload" />
        <activity-log :visible="dialogActivityComm" @close="dialogActivityComm = false" :data="historyData" />
        <delete :visible="dialogDeleteComm" @close="dialogDeleteComm = false" @delete="deleteComm" />
      </div>
    </div>
  </div>
</template>

<script>
import AllSeller from "./AllSeller.vue";
import QuickFilterInput from "./QuickFilterInput.vue";
import AddComm from "./AddComm.vue";
import "../../../src/assets/css/viewclients.css";
import EditComm from "./EditComm.vue";
import Delete from "./Delete.vue";
import ActivityLog from "./ActivityLog.vue";
import Helper from "@/resource/Helper"
import axios from "axios";
import Pagination from "./Pagination.vue";


export default {
  name: "CommissionSplit",
  components: {
    AllSeller,
    QuickFilterInput,
    AddComm,
    EditComm,
    Delete,
    ActivityLog,
    Pagination
  },
  data() {
    return {
      breadcrumbItems: [{ title: "Commission Dashboard", active: true }, { title: "Commission Split", active: true }],
      dialog: false,
      dialogAddComm: false,
      dialogEditComm: false,
      dialogDeleteComm: false,
      dialogActivityComm: false,
      tableKey: 0,
      rows: [],
      pagination: {
        current_page: 1,
        from: null,
        last_page: 1,
        path: '',
        per_page: 10,
        to: null,
        total: 0,
        total_records: 0
      },
      filters: {},
      historyData: {},
      selected: {
        deleteId: null,
        editId: null,
      },
      searchParams: {
        to_rep_name: '',
        seller_rep_name: '',
        status: '',
        effective_date: ''
      },
      selectedSplit: {},
      activeDropdown: null,
    };
  },
  computed: {
    paginationData() {
      return {
        ...this.pagination,
        data: this.rows,
        record_range: [this.pagination.from, this.pagination.to],
        total_records: this.pagination.total
      };
    },
    repId(){
      return this.$store.getters.repId;
    }
  },
  methods: {
    handleClickOutside(event) {
      if (this.activeDropdown && !event.target.closest('.dropdown')) {
        this.activeDropdown = null;
      }
    },
    handlePageChange({ page, pageSize }) {
      if (this.pagination.current_page !== page || this.pagination.per_page !== pageSize) {
        const loader = this.$loading.show();
        this.pagination.current_page = page;
        this.pagination.per_page = pageSize;
        this.getCommissionSplit().finally(() => {
          loader.hide();
        });
      }
    },
    handlePaginationUpdate(updatedPagination) {
      const hasChanges =
        (updatedPagination.current_page && updatedPagination.current_page !== this.pagination.current_page) ||
        (updatedPagination.per_page && updatedPagination.per_page !== this.pagination.per_page);

      if (hasChanges) {
        const loader = this.$loading.show();
        this.pagination = {
          ...this.pagination,
          current_page: updatedPagination.current_page || this.pagination.current_page,
          per_page: updatedPagination.per_page || this.pagination.per_page,
          from: updatedPagination.record_range ? updatedPagination.record_range[0] : this.pagination.from,
          to: updatedPagination.record_range ? updatedPagination.record_range[1] : this.pagination.to,
          total: updatedPagination.total_records || this.pagination.total
        };

        this.getCommissionSplit().finally(() => {
          loader.hide();
        });
      }
    },
    sellerRepsDisplay(sellerReps) {
      if (!sellerReps) return '';
      return `${sellerReps.name} (${sellerReps.code})`;
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const [year, month, day] = dateString.split('-');
      return `${month}/${day}/${year}`;
    },
    changeStatus(index, newStatus, id) {
      let loader = this.$loading.show();
      const headers = {
            'Content-Type': 'application/json',
            'X-Commission-Token': Helper.commissionRepToken()
        };
        
      axios.post(`${Helper.commissionUrl()}v1/rep/special-commission-status/update/${id}`, {
        isActive: newStatus === 'Enable' ? 1 : 0,
        updated_by: this.repId
      }, { headers })
      .then(() => {
        Helper.infoMessage(this, 'success', 'Commission status updated successfully.');
        this.rows[index].status = newStatus;
        this.toggleDropdown(index);
      })
      .catch(error => {
        console.error('Error updating status:', error);
        Helper.infoMessage(this, 'error', 'Something went wrong. Please try again.');
      })
      .finally(() => {
        loader.hide();
      });
    },
    openDialog() {
      this.dialog = true;
    },
    openAddDialog() {
      this.dialogAddComm = true;
    },
    openEditDialog(row) {
      this.dialogEditComm = true;
      this.selectedSplit = row;
    },
    async getHistory(id) {
      let loading = this.$loading.show();
      const config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Commission-Token': Helper.commissionRepToken()
        }
      };
      await axios.get(
        `${Helper.commissionUrl()}v1/rep/getCommissionHistory/${id}`,
        config
      ).then(({ data }) => {
        this.dialogActivityComm = true;
        this.historyData = data.data;
      }).catch((error) => {
        console.log(error);
        this.$toast.error('Failed to load commission history. Please try again later.');
      }).finally(() => {
        loading.hide();
      });
    },

    async deleteComm() {
      const loading = this.$loading.show();

      const headers = {
        'Content-Type': 'application/json',
        'X-Commission-Token': Helper.commissionRepToken()
      };

      try {
        await axios.post(
          `${Helper.commissionUrl()}v1/rep/deleteSpecialCommission/${this.selected.deleteId}`,
          {
              "updated_by": this.repId
          },
          { headers }
        );
        this.dialogDeleteComm = false;
        this.$toast.success('Commission deleted successfully');
        this.getCommissionSplit();
      } catch (error) {
        console.error('Error deleting commission:', error);
        this.$toast.error('Failed to delete commission. Please try again later.');
      } finally {
        this.selected.deleteId = null;
        loading.hide();
      }
    },
    openDeleteDialog(id) {
      this.selected.deleteId = id;
      this.dialogDeleteComm = true;
    },
    async handleSearch({ label, value, status, effective_date }) {
      let loader = this.$loading.show();
      
      try {
        const paramMap = {
          'To Rep name': 'to_rep_name',
          'Seller Rep name': 'seller_rep_name',
          'Status': 'status',
          'Effective Date': 'effective_date'
        };

        Object.keys(this.searchParams).forEach(key => {
          this.searchParams[key] = '';
        });

        const paramKey = paramMap[label];
        if (paramKey) {
          this.searchParams[paramKey] = value;
        }

        if (status !== undefined) {
          this.searchParams.status = status;
        }

        if (effective_date) {
          const date = new Date(effective_date);
          if (!isNaN(date.getTime())) {
            const formattedDate = date.toISOString().split('T')[0];
            this.searchParams.effective_date = formattedDate;
          } else {
            this.searchParams.effective_date = effective_date;
          }
        } else if (label === 'Effective Date' && !effective_date) {
          this.searchParams.effective_date = '';
        }

        this.pagination.current_page = 1;
        
        this.filters = Object.fromEntries(
          Object.entries(this.searchParams).filter(([, value]) => {
            return value !== '' && value !== null && value !== undefined;
          })
        );
        
        await this.getCommissionSplit();
        
      } catch (error) {
        console.error('Search error:', error);

        this.$set(this, 'rows', []);
        this.tableKey++;
        this.$toast.error('An error occurred while searching. Please try again.');
      } finally {
        loader.hide();
      }
    },

    getParams() {
      return {
        params: {
          page: this.pagination.current_page,
          per_page: this.pagination.per_page,
          ...this.filters
        },
      };
    },
    async getCommissionSplit() {
      try {
        const config = {
          ...this.getParams(),
          headers: {
            'Content-Type': 'application/json',
            'X-Commission-Token': Helper.commissionRepToken()
          }
        };

        
        const response = await axios.get(
          `${Helper.commissionUrl()}v1/rep/getSpecialCommission?agent_id=605`,
          config
        );

        
        const responseData = response.data?.data || {};
        const apiData = responseData.data || [];
        
        this.$set(this, 'rows', [...apiData]);
        
        this.$set(this, 'pagination', {
          current_page: responseData.current_page || 1,
          from: responseData.from || null,
          last_page: responseData.last_page || 1,
          path: responseData.path || window.location.href,
          per_page: parseInt(responseData.per_page) || 10,
          to: responseData.to || null,
          total: responseData.total || 0,
          total_records: responseData.total || 0
        });
        
        this.tableKey++;
        await this.$nextTick();
      
        return response.data;
      } catch (error) {
        console.error('Error fetching commission splits:', error);
        this.$set(this, 'rows', []);
        this.$set(this, 'pagination', {
          current_page: 1,
          from: 0,
          last_page: 1,
          path: '',
          per_page: 10,
          to: 0,
          total: 0,
          total_records: 0
        });
        this.tableKey++;
        await this.$nextTick();
        this.$toast.error('Failed to load commission splits. Please try again later.');
        throw error;
      }
    },
    closeComm(type) {
      if (type === 'add') {
        this.dialogAddComm = false;
      } else {
        this.dialogEditComm = false;
      }
    },
    async reload(){
      await this.getCommissionSplit();
    },
    toggleDropdown(id) {
      this.activeDropdown = this.activeDropdown === id ? null : id;
    }
  },
  mounted() {
    this.getCommissionSplit();
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>

<style>
.pointer {
  cursor: pointer;
}

.gap-3 {
  gap: 10px;
}

.split-pill {
  background: #eaedf0;
  border-radius: 50px;
  padding: 0.5rem 1rem;
  max-width: fit-content;
}

.icon-btn {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
  margin: 5px;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.icon-btn:hover {
  transform: scale(1.1);
}

.status-btn {
  border-radius: 25px;
  padding: 6px 16px;
  font-weight: 500;
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  min-width: max-content;
}

.status-btn:hover {
  color: #fff;
}

.status-btn .dropdown-item.active,
.dropdown-item:active {
  background-color: #f3f3f3 !important;
  color: #15171a !important;
}

.btn-enable {
  background-color: #28a745;
  color: #fff;
}

.stat-text {
  font-weight: 500 !important;
  display: flex;
  align-items: center;
  gap: 6px;
}

.enable-txt {
  color: #28a745 !important;
}

.enable-dot {
  height: 8px;
  width: 8px;
  border-radius: 50px;
  background: #28a745;
}

.disable-txt {
  color: #6c757d !important;
}

.disable-dot {
  height: 8px;
  width: 8px;
  border-radius: 50px;
  background: #6c757d;
}

.btn-disable {
  background-color: #6c757d;
  color: #fff;
}

.dropdown-menu a {
  cursor: pointer;
}

.button-dropdown {
  background-color: #28a745;
  color: white;
  border: none;
  padding: 8px 18px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 20px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  transition: background-color 0.2s;
}

.button-dropdown:hover {
  background-color: #218838;
  /* darker green on hover */
}

.button-dropdown::after {
  content: "▾";
  /* small downward arrow */
  margin-left: 6px;
  font-size: 12px;
}

.fw-medium {
  font-weight: 700;
}

.highlight {
  color: #0ef;
  font-weight: 600;
}

.btn-section {
  max-width: fit-content;
}

.ce-content {
  background: #efefef !important;
}

.common-content {
  width: 100%;
  background-color: #fff;
  padding: 15px;
  min-height: 500px;
}

.common-content h1 {
  font-size: 24px;
  font-weight: bold;
  color: #000;
  padding: 15px 0;
  text-transform: uppercase;
  margin: 0;
}

table {
  border: 1px solid #dee2e6;
}

table tr th,
table tr td {
  padding: 1rem;
}

table tr td {
  color: #323c47;
}

.btn-success {
  border: none;
}

label {
  color: #5e5e5e;
  font-size: 14px;
  margin-bottom: 8px;
  font-weight: 500;
}

.seller-reps {
  min-width: 150px;
}

.status-drp-down {
  margin-top: 3rem !important;
}
</style>
